// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OfRWW","question":"styles_question__3POXR","inputVisibleButton":"styles_inputVisibleButton__3AO6c","note":"styles_note__jM05K"};